import { hbs } from 'ember-cli-htmlbars';
import { workflowComponent } from '@banking/ui/services/investments-workflow';
import { failedToFetchInvestmentDataForBankingHome, isInvestmentAccountFullyCreated, isFetchingInvestmentAccountsAndEligibility, shouldSkipLinking } from '@banking/ui/workflows/investments';

// TODO: These should be exported from for a source of truth our
// implementation's types can be "tested" against.

const template = hbs`
  {{#if this.isInvestmentAccountFullyCreated}}
    <Banking::Investments::Balances
      class="banking-page__section"
      @goToInvestments={{this.goToInvestments}}
      data-test-investments-balances/>
  {{else if (and (not this.isInvestmentModalOpen) this.showLoader)}}
    <Banking::Launchpad::LoaderSection
      class="banking-page__section"
      @title={{t "banking.launchpad.investments.title"}}
    />
    {{else if (and (not this.isInvestmentModalOpen) this.showError)}}
    <section class="banking-page__section" data-test-investment-section-error>
      <Banking::Launchpad::ErrorCard
        @title={{t "banking.launchpad.investments.title"}}
      />
    </section>
  {{else}}
    <Banking::Investments::Upsell
      class="banking-page__section"
      @goToInvestments={{this.goToInvestments}}
      @shouldSkipLinking={{this.shouldSkipLinking}}
      data-test-investments-upsell/>
  {{/if}}
  `;
const mapStateToProps = (state, ownArgs) => {
  return {
    goToInvestments: ownArgs.goToInvestments,
    isInvestmentModalOpen: state.isModalOpen,
    isInvestmentAccountFullyCreated: isInvestmentAccountFullyCreated(state),
    shouldSkipLinking: shouldSkipLinking(state),
    showError: failedToFetchInvestmentDataForBankingHome(state),
    showLoader: isFetchingInvestmentAccountsAndEligibility(state)
  };
};
const mapActionsToProps = () => ({});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);